import React from 'react';
import PlusIcon from './PlusIcon';
import FilterIcon from './FilterIcon';
import MagnifierIcon from './MagnifierIcon';
import AppButton from './AppButton';
import ButtonRow from './ButtonRow';

type PageHeaderControlsProps = {
  title: string;
  addLabel: string;
  onAdd: () => void;
  filterOpen: boolean;
  onToggleFilter: () => void;
  filterSectionId: string;
  showFiltersLabel: string;
  hideFiltersLabel: string;
  compact?: boolean;
  onToggleCompact?: () => void;
  searchLabel: string;
  onSearch: () => void;
  clearFiltersLabel: string;
  onClearFilters: () => void;
  children: React.ReactNode;
};

const PageHeaderControls: React.FC<PageHeaderControlsProps> = ({
  title,
  addLabel,
  onAdd,
  filterOpen,
  onToggleFilter,
  filterSectionId,
  showFiltersLabel,
  hideFiltersLabel,
  compact,
  onToggleCompact,
  searchLabel,
  onSearch,
  clearFiltersLabel,
  onClearFilters,
  children,
}) => {
  return (
    <>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 20 }}>{title}</h1>

      <div className="page-header-toolbar">
        <AppButton onClick={onAdd} variant="green" size="standard" className="page-header-btn">
          <PlusIcon size={16} color="#fff" /> {addLabel}
        </AppButton>

        <AppButton
          className="page-header-btn"
          type="button"
          variant="blue"
          size="standard"
          onClick={onToggleFilter}
          aria-expanded={filterOpen}
          aria-controls={filterSectionId}
        >
          <FilterIcon size={16} color="#fff" /> {filterOpen ? hideFiltersLabel : showFiltersLabel}
        </AppButton>

        {typeof compact === 'boolean' && onToggleCompact && (
          <button
            type="button"
            onClick={onToggleCompact}
            aria-pressed={compact}
            title="Toggle compact list view"
            className={`compact-toggle${compact ? ' compact-toggle-on' : ''}`}
          >
            <span className="compact-toggle-track">
              <span className="compact-toggle-thumb" style={{ left: compact ? 16 : 2 }} />
            </span>
            Compact
          </button>
        )}
      </div>

      <div
        id={filterSectionId}
        className={`collapsible-filter${filterOpen ? ' open' : ''}`}
        style={
          filterOpen
            ? {
                background: '#fff',
                padding: 20,
                borderRadius: 8,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                marginBottom: 20,
                marginTop: 12,
              }
            : {
                padding: 0,
                margin: 0,
                border: 'none',
                boxShadow: 'none',
                background: 'transparent',
              }
        }
      >
        {children}
        <ButtonRow className="filter-action-row" compact>
          <AppButton onClick={onSearch} variant="blue" size="standard">
            <MagnifierIcon size={18} color="#fff" /> {searchLabel}
          </AppButton>
          <AppButton onClick={onClearFilters} variant="blue" size="standard">
            {clearFiltersLabel}
          </AppButton>
        </ButtonRow>
      </div>
    </>
  );
};

export default PageHeaderControls;
